import { render, staticRenderFns } from "./BarCode.vue?vue&type=template&id=1c013fdb&"
import script from "./BarCode.vue?vue&type=script&lang=js&"
export * from "./BarCode.vue?vue&type=script&lang=js&"
import style0 from "./BarCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
